import { Injectable } from '@angular/core'; 
import 'rxjs/add/observable/of';
import { StorageService } from '../providers/storage.service'; 
import { tokenNotExpired } from "angular2-jwt";


@Injectable()
export class AuthService {
    
    constructor(private storage: StorageService) { }

    loggedIn(): boolean {
        return tokenNotExpired();
    }

    getToken(): string {
        return this.storage.readString("token");
    }

}


// WEBPACK FOOTER //
// ./src/providers/auth.service.ts